<template>
  <x-dialog
    :dialogState="showDialog"
    width="50%"
    :dialogTitle="dialogTitle"
    :data-test-id="dataTestId"
    @toggleModal="closeDialog"
  >
    <template slot="dialog_data">
      <loader v-if="loadingState" />
      <v-card-text class="px-8">
        <v-tabs
          v-model="tab"
          slider-color="#58E2C2"
          :data-test-id="`${dataTestId}__user-details-form-tabs-wrapper`"
        >
          <v-tabs-slider color="#58E2C2"></v-tabs-slider>
          <v-tab :data-test-id="`${dataTestId}__account-details`" :key="1">Account details</v-tab>
          <v-tab :data-test-id="`${dataTestId}__account-status`" :key="2">Account status</v-tab>
          <v-tab :data-test-id="`${dataTestId}__additional-details`" :key="3">Additional details</v-tab>
          <v-tab :data-test-id="`${dataTestId}__security`" :key="4" v-if="!hasSSOConsent">
            <v-icon
              v-if="
                userDetails.customData && userDetails.customData.ENABLED_2FA
              "
              >security</v-icon
            >Security
          </v-tab>

          <v-tabs-items v-model="tab">
            <!-- tab 1-->
            <v-tab-item key="1">
              <v-card flat tile class="px-6">
                <v-row align="center">
                  <v-col md="3" class="pl-0">
                    <span class="formInputLabel">
                      Full name
                      <span class="red--text">*</span>
                    </span>
                  </v-col>
                </v-row>
                <v-row class="py-0">
                  <v-row>
                    <v-col
                      md="4"
                      class="pr-1"
                      :data-test-id="
                        `${dataTestId}__first-name-input-box-wrapper`
                      "
                    >
                      <v-text-field
                        label="First Name"
                        solo
                        filled
                        flat
                        height="52px"
                        background-color="#E5E5E5 !important"
                        autocomplete="off"
                        v-model="userDetails.firstName"
                        class="fname"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      md="4"
                      class="pr-1"
                      :data-test-id="
                        `${dataTestId}__middle-name-input-box-wrapper`
                      "
                    >
                      <v-text-field
                        label="Middle Name"
                        solo
                        filled
                        flat
                        success
                        height="52px"
                        background-color="#E5E5E5 !important"
                        autocomplete="off"
                        v-model="userDetails.middleName"
                        class="fname"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      md="4"
                      :data-test-id="
                        `${dataTestId}__last-name-input-box-wrapper`
                      "
                    >
                      <v-text-field
                        label="Last Name"
                        solo
                        filled
                        flat
                        height="52px"
                        background-color="#E5E5E5 !important"
                        autocomplete="off"
                        v-model="userDetails.lastName"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-row>

                <v-row align="center">
                  <v-col md="3" class="pl-0">
                    <span class="formInputLabel">
                      Primary email address
                      <span class="red--text">*</span>
                    </span>
                  </v-col>
                </v-row>
                <v-row :data-test-id="`${dataTestId}__email-input-box-wrapper`">
                  <v-text-field
                    label="firstname.lastname@xift.com"
                    solo
                    filled
                    flat
                    height="52px"
                    background-color="#E5E5E5 !important"
                    v-model="userDetails.primaryEmail"
                  ></v-text-field>
                </v-row>
                <v-row>
                  <v-col md="8" class="pl-0">
                    <span class="formInputLabel">Email aliases</span>
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-for="(item, index) in emailAlias"
                  :key="item.id"
                >
                  <v-row align="center">
                    <v-col
                      md="7"
                      :data-test-id="
                        `${dataTestId}__email-alias-${index +
                          1}-input-box-wrapper`
                      "
                    >
                      <v-text-field
                        @input="validateEmail(item)"
                        label="type email alias then press + to add"
                        solo
                        filled
                        :id="item.id"
                        flat
                        height="52px"
                        background-color="#E5E5E5 !important"
                        v-model="item.val"
                        width="80%"
                      ></v-text-field>
                    </v-col>
                    <v-col md="1" class="text-center">
                      <v-icon
                        color="#58E2C2"
                        size="25"
                        v-if="item.validateEmailIcon"
                        :id="item.id"
                        >done</v-icon
                      >
                      <v-icon
                        v-if="item.errorValidate"
                        color="red"
                        size="25"
                        :id="item.id"
                        :data-test-id="
                          `${dataTestId}__email-alias-${index + 1}__clear-icon`
                        "
                        @click="removeAlias(item)"
                        >clear</v-icon
                      >
                    </v-col>
                    <v-col md="1" class="text-center">
                      <v-icon
                        v-if="item.addNewAliasIconVisible"
                        color="#58E2C2"
                        size="25"
                        :disabled="item.addNewAliasIcon || item.val === ''"
                        :data-test-id="
                          `${dataTestId}__email-alias-${index + 1}__add-icon`
                        "
                        @click="addAlias"
                        >add</v-icon
                      >
                    </v-col>
                  </v-row>
                </v-row>

                <v-row align="center" v-if="userDetails.groupMembers">
                  <v-col md="3" class="pl-0">
                    <span class="formInputLabel">Group Members:</span>
                  </v-col>
                </v-row>
                <v-row>
                  <template v-for="(member, index) in userDetails.groupMembers">
                    <span :key="index" v-if="index <= 2">
                      {{ getMemberNameEmail(member) }}
                      <br />
                    </span>
                  </template>
                  <template v-if="showMore">
                    <div
                      v-for="(member, index) in userDetails.groupMembers"
                      :key="(index + 1) * 100"
                    >
                      <span v-if="index >= 3">
                        {{ getMemberNameEmail(member) }}
                        <br />
                      </span>
                    </div>
                  </template>
                  <v-btn
                    v-if="
                      userDetails.groupMembers !== null &&
                        userDetails.groupMembers.length > 3
                    "
                    text
                    :ripple="false"
                    color="#58e2c2"
                    link
                    class="pa-0"
                    :data-test-id="`${dataTestId}__toggle-show-more-btn`"
                    @click="showMore = !showMore"
                  >
                    <v-icon class="pl-0" v-if="!showMore">add</v-icon>
                    <v-icon class="pl-0" v-if="showMore">remove</v-icon>
                    <span v-if="!showMore">Click to show more</span>
                    <span v-if="showMore">Click to show less</span>
                  </v-btn>
                </v-row>
              </v-card>
            </v-tab-item>
            <!-- tab 1-->

            <!-- tab 2-->
            <v-tab-item key="2">
              <v-card flat tile class="px-6">
                <v-row>
                  <v-col md="3" class="pl-0">
                    <span class="formInputLabel">Account status</span>
                  </v-col>
                </v-row>
                <v-row
                  class="positionRelative"
                  :data-test-id="
                    `${dataTestId}__account-status-select-box-wrapper`
                  "
                >
                  <v-select
                    v-if="canChangeStatus && !isArchivedUser"
                    :items="statusType"
                    flat
                    outline
                    solo
                    v-model="userDetails.status"
                    append-icon="keyboard_arrow_down"
                    class="cursorPointer"
                    background-color="#E5E5E5 !important"
                    item-value="id"
                    item-text="label"
                    height="52px"
                    :attach="
                      `[data-test-id='${dataTestId}__account-status-select-box-wrapper']`
                    "
                  ></v-select>
                  <span v-else>{{ userDetails.status || '' }}</span>
                </v-row>
                <v-row>
                  <v-col md="3" class="pl-0">
                    <span class="formInputLabel">License Type</span>
                  </v-col>
                </v-row>
                <v-row
                  class="positionRelative"
                  :data-test-id="
                    `${dataTestId}__license-type-select-box-wrapper`
                  "
                >
                  <v-select
                    v-if="$can('manage', 'system')"
                    :items="licenseType"
                    flat
                    outline
                    solo
                    v-model="userDetails.license"
                    append-icon="keyboard_arrow_down"
                    class="cursorPointer"
                    background-color="#E5E5E5 !important"
                    item-value="id"
                    item-text="label"
                    height="52px"
                    :attach="
                      `[data-test-id='${dataTestId}__license-type-select-box-wrapper']`
                    "
                  ></v-select>
                  <span v-else>
                    {{
                      userDetails.license ? titleCase(userDetails.license) : ''
                    }}
                  </span>
                </v-row>
                <v-row align="center">
                  <v-col md="3" class="pl-0">
                    <span class="formInputLabel">Roles</span>
                  </v-col>
                </v-row>
                <v-row
                  :data-test-id="`${dataTestId}__roles-select-box-wrapper`"
                >
                  <v-autocomplete
                    v-if="canAssignRole"
                    ref="roleSelect"
                    name="roleData"
                    v-model="roleName"
                    :items="availableRoles"
                    item-text="val"
                    item-value="id"
                    v-on:keyup.enter="addItems(roleName, roleSelectedList)"
                    v-on:change="addItems(roleName, roleSelectedList)"
                    append-icon="keyboard_arrow_down"
                    background-color="#E5E5E5 !important"
                    height="52px"
                    filled
                    flat
                    solo
                    hide-selected
                    type
                    label="Role Name"
                    :menu-props="{
                      contentClass: `${dataTestId}__roles-select-box-list`
                    }"
                  ></v-autocomplete>
                </v-row>
                <v-row>
                  <div
                    v-if="roleSelectedList && roleSelectedList.length > 0"
                    class="list-container"
                    :data-test-id="`${dataTestId}__roles-tag-list`"
                  >
                    <tag
                      v-for="(item, index) in roleSelectedList"
                      data-class="dynamicTagsdark"
                      :key="item.id"
                      :text="item.val"
                      :showDelete="canAssignRole"
                      :data-test-id="
                        `${dataTestId}__roles-tag-list-item-${index + 1}`
                      "
                      @click="deleteItem(item, roleSelectedList)"
                    ></tag>
                  </div>
                </v-row>
              </v-card>
            </v-tab-item>
            <!-- tab 2-->

            <!-- tab 3-->
            <v-tab-item key="3">
              <v-card flat tile class="px-6">
                <v-row>
                  <v-col md="3" class="pl-0">
                    <span class="formInputLabel">Telephone</span>
                  </v-col>
                </v-row>
                <v-row>
                  <vue-tel-input
                    v-bind="bindProps"
                    v-model="userDetails.telephone"
                    :class="telClass"
                    :data-test-id="`${dataTestId}__telephone-input-box-wrapper`"
                    @validate="phoneNumberValidation"
                    @onInput="phoneNumberValidation"
                  ></vue-tel-input>
                </v-row>
                <v-row align="center">
                  <v-col md="3" class="pl-0">
                    <span class="formInputLabel">Street Address</span>
                  </v-col>
                </v-row>
                <v-row
                  :data-test-id="`${dataTestId}__street-input-box-wrapper`"
                >
                  <v-text-field
                    solo
                    filled
                    flat
                    height="52px"
                    background-color="#E5E5E5 !important"
                    v-model="userDetails.addresses.streetAddress"
                  ></v-text-field>
                </v-row>

                <v-row align="center">
                  <v-col md="3" class="pl-0">
                    <span class="formInputLabel">Locality</span>
                  </v-col>
                </v-row>
                <v-row
                  :data-test-id="`${dataTestId}__locality-input-box-wrapper`"
                >
                  <v-text-field
                    solo
                    filled
                    flat
                    height="52px"
                    background-color="#E5E5E5 !important"
                    v-model="userDetails.addresses.locality"
                  ></v-text-field>
                </v-row>

                <v-row align="center">
                  <v-col md="3" class="pl-0">
                    <span class="formInputLabel">County/City</span>
                  </v-col>
                </v-row>
                <v-row :data-test-id="`${dataTestId}__city-input-box-wrapper`">
                  <v-text-field
                    solo
                    filled
                    flat
                    height="52px"
                    background-color="#E5E5E5 !important"
                    v-model="userDetails.addresses.region"
                  ></v-text-field>
                </v-row>

                <v-row align="center">
                  <v-col md="3" class="pl-0">
                    <span class="formInputLabel">Country</span>
                  </v-col>
                </v-row>
                <v-row>
                  <country-select
                    class="country-select"
                    v-model="userDetails.addresses.country"
                    topCountry="GB"
                    :country="userDetails.addresses.country"
                    :data-test-id="`${dataTestId}__country-select-box-wrapper`"
                  />
                </v-row>
                <v-row align="center">
                  <v-col md="3" class="pl-0">
                    <span class="formInputLabel">Postcode</span>
                  </v-col>
                </v-row>
                <v-row
                  :data-test-id="`${dataTestId}__postal-code-input-box-wrapper`"
                >
                  <v-text-field
                    solo
                    filled
                    flat
                    height="52px"
                    background-color="#E5E5E5 !important"
                    v-model="userDetails.addresses.postalCode"
                  ></v-text-field>
                </v-row>

                <v-row align="center">
                  <v-col md="3" class="pl-0">
                    <span class="formInputLabel">Job Title</span>
                  </v-col>
                </v-row>
                <v-row
                  :data-test-id="`${dataTestId}__job-title-input-box-wrapper`"
                >
                  <v-text-field
                    solo
                    filled
                    flat
                    height="52px"
                    background-color="#E5E5E5 !important"
                    v-model="userDetails.jobTitle"
                  ></v-text-field>
                </v-row>

                <v-row align="center">
                  <v-col md="3" class="pl-0">
                    <span class="formInputLabel">Department</span>
                  </v-col>
                </v-row>
                <v-row
                  :data-test-id="`${dataTestId}__department-input-box-wrapper`"
                >
                  <v-text-field
                    solo
                    filled
                    flat
                    height="52px"
                    background-color="#E5E5E5 !important"
                    v-model="userDetails.department"
                  ></v-text-field>
                </v-row>

                <v-row
                  align="center"
                  class="mr-0"
                  v-if="userDetails.externalIds.length > 0"
                >
                  <v-col md="8" class="pl-0">
                    <span class="formInputLabel">External Id(s)</span>
                  </v-col>
                  <v-row
                    v-for="item in userDetails.externalIds"
                    :key="item.externalId"
                  >
                    <v-col md="9">
                      <span>{{ item.platform }}|{{ item.externalId }}</span>
                    </v-col>
                  </v-row>
                </v-row>
              </v-card>
            </v-tab-item>
            <!-- tab 3-->

            <!-- tab 4-->
            <v-tab-item v-if="!hasSSOConsent" key="4">
              <v-card flat class="px-6">
                <v-row>
                  <v-col md="3" class="pl-0">
                    <span class="formInputLabel mt-0">MFA</span>
                  </v-col>
                  <v-col md="9">
                    <ToggleButtonConfigurable
                      id="mfa-toggle"
                      :toggleState="
                        userDetails.customData &&
                          userDetails.customData.ENABLED_2FA
                      "
                      :disable="MFAloading"
                      :data-test-id="`${dataTestId}__mfa-toggle-btn`"
                      @toggleValue="
                        status => changeMFAStatus(status, userDetails)
                      "
                    />
                  </v-col>
                </v-row>
                <!-- -->
                <v-row align="center" mt-4 v-if="canChangePassword()">
                  <v-col md="3" class="pl-0">
                    <span class="formInputLabel mt-0">New password</span>
                  </v-col>
                  <v-col
                    md="9"
                    class="text-left"
                    :class="{ 'show-password': passwordChanged }"
                  >
                    <v-btn
                      v-if="!passwordChanged"
                      tile
                      class="white--text filled-btn"
                      color="#58E2C2"
                      :disabled="passwordLoader"
                      :data-test-id="`${dataTestId}__generate-password-btn`"
                      @click="generatePassword"
                    >
                      {{ passwordBtnText }}
                    </v-btn>
                    <label v-if="passwordChanged">
                      {{ generatedPassword }}
                    </label>
                  </v-col>
                </v-row>
                <v-row align="center" mt-4 v-if="passwordChanged">
                  <v-col md="3"></v-col>
                  <v-col md="9" class="text-left pl-0">
                    {{ $message.PASSWORD_CARE_HANDLE }}
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <!-- tab 4-->
          </v-tabs-items>
        </v-tabs>
      </v-card-text>
      <v-card-actions class="px-10 py-7">
        <v-row justify="end">
          <x-button
            outline
            color="#58E2C2"
            buttonText="Cancel"
            :data-test-id="`${dataTestId}__cancel-btn`"
            @click="closeDialog"
          />
          <v-spacer></v-spacer>
          <x-button
            v-if="tab !== 0"
            color="#58E2C2"
            buttonText=" Previous"
            :data-test-id="`${dataTestId}__prev-btn`"
            @click="prev"
          />
          <x-button
            v-if="tab !== finalTab"
            color="#58E2C2"
            class="ml-2"
            buttonText=" Next"
            :data-test-id="`${dataTestId}__next-btn`"
            @click="next"
          />
          <x-button
            v-if="tab === finalTab"
            color="#58E2C2"
            class="ml-2"
            buttonText=" Save"
            :data-test-id="`${dataTestId}__save-btn`"
            @click="saveVal"
          />
        </v-row>
      </v-card-actions>
    </template>
  </x-dialog>
</template>

<script>
import { VueTelInput } from 'vue-tel-input';
var findIndex = require('lodash.findindex');
import UserService from '../../../services/UserService';
import ToggleButtonConfigurable from '@/components/Common/ToggleButtonConfigurable';
import { mapState } from 'vuex';
export default {
  components: {
    VueTelInput,
    ToggleButtonConfigurable
  },
  props: ['editUserDialog', 'userDetails', 'dataTestId'],
  data() {
    return {
      showMore: false,
      finalTab: 2,
      originalStatus: this.userDetails.status,
      passwordLoader: false,
      passwordChanged: false,
      generatedPassword: '',
      passwordBtnText: 'Generate Password',
      bindProps: {
        mode: 'international',
        defaultCountry: 'GB'
      },
      showDialog: false,
      dialogTitle: 'Edit account',
      tab: null,
      statusType: [
        {
          id: 'ACTIVE',
          label: 'ACTIVE'
        },
        {
          id: 'DISABLED',
          label: 'DISABLED'
        },
        {
          id: 'ARCHIVED',
          label: 'ARCHIVED'
        }
      ],
      emailAlias: [
        {
          id: 'alias0',
          val: '',
          label: 'Email aliases:',
          status: false,
          validateEmailIcon: false,
          errorValidate: false,
          addNewAliasIcon: false,
          addNewAliasIconVisible: true
        }
      ],
      counter: 0,
      MFAloading: false,
      MFAStatusChanged: false,
      validateEmailIcon: false,
      addNewAliasIcon: true,
      prevBtn: false,
      nextBtn: false,
      saveBtn: false,
      errorValidate: false,
      roleList: [],
      roleName: '',
      roleSelectedList: [],
      roleListWhole: [],
      licenseType: [
        {
          id: 'charity',
          label: 'Charity'
        },
        {
          id: 'company',
          label: 'Company'
        },
        {
          id: 'partner',
          label: 'Partner'
        },
        {
          id: 'student',
          label: 'Student'
        },
        {
          id: 'trail',
          label: 'Trail'
        }
      ],
      min_length: 1,
      showRemoveButton: false,
      telClass: '',
      loadingState: false
    };
  },
  mounted() {
    this.showDialog = this.editUserDialog;
    this.setAliases();
    this.getRoles();
    this.userDetails.roles.forEach(ele => {
      let temp = {
        id: ele,
        val: ele
      };
      this.roleSelectedList.push(temp);
      temp = {};
    });
    this.roleSelectedList = this.removeUnderscore(this.roleSelectedList);
    this.userDetails.license = this.userDetails.license.toLowerCase();
    // if (this.userDetails.telephone === null) { this.userDetails.telephone = ''; }
    this.userDetails.telephone || '';
  },
  created: function() {
    this.emailAliasLimit = 100;
    document.addEventListener('keyup', this.escapeKeyListener);
  },
  destroyed: function() {
    document.removeEventListener('keyup', this.escapeKeyListener);
  },
  computed: {
    ...mapState({
      hasSSOConsent: state => state?.singleSignOnStatus?.HAS_CONSENT,
      loggedInUserId: state => state?.userInformation?.userId || '',
      userIdNameMap: state => state?.userInfo?.userIdNameMap || {}
    }),
    groupMembers: function() {
      if (this.userDetails.groupMembers !== null) {
        // eslint-disable-next-line
        if (this.userDetails.groupMembers.length <= 3) {
          return this.userDetails.groupMembers;
        }
        if (this.showMore) {
          return this.userDetails.groupMembers;
        } else {
          // eslint-disable-next-line
          return this.userDetails.groupMembers.slice(0, 3);
        }
      }
      return 0;
    },
    availableRoles() {
      return this.roleList.filter(role => {
        const isRoleSelected = this.roleSelectedList.findIndex(
          selectedRole => selectedRole.id === role.id
        );
        return isRoleSelected === -1;
      });
    },
    canAssignRole: function() {
      if (this.currentlySelectedOrgId !== this.orgId) {
        return this.$can('assign', 'child_organisation_role');
      }
      return this.$can('assign', 'role');
    },
    canChangeStatus: function() {
      return this.userDetails.userId !== this.loggedInUserId;
    },
    isArchivedUser() {
      return (this.userDetails?.status || '').toUpperCase() === this.$enums.userStatuses.ARCHIVED;
    }
  },
  methods: {
    getMemberNameEmail(id) {
      let user = this.userIdNameMap[id];
      let name = this.formatUserName(user);
      let email = user?.email?.[0];
      return `${name} - ${email}`;
    },
    escapeKeyListener: function(evt) {
      if (evt.keyCode === this.escapeKeyCode && this.showDialog) {
        this.closeDialog();
      }
    },
    canChangePassword() {
      // if this user is from same org
      // if this user is from other org
      if (this.userDetails.orgId === this.orgId) {
        if (this.$can('change', 'password')) {
          this.finalTab = 3;
          return true;
        }
      } else if (this.$can('change', 'child_organisation_password')) {
        this.finalTab = 3;
        return true;
      } else {
        this.finalTab = 2;
        return false;
      }
    },
    async generatePassword() {
      this.generatedPassword = '';
      this.passwordLoader = true;
      this.passwordBtnText = 'generating...';
      this.passwordChanged = false;
      try {
        let passwordResponse = await UserService.generatePassword(
          this.userDetails.userId
        );
        if (passwordResponse.data.success) {
          this.passwordChanged = true;
          this.passwordLoader = false;
          this.passwordBtnText = this.$message.GENERATE_PASSWORD;
          this.generatedPassword = passwordResponse.data.body;
        } else {
          this.snackbar('error', this.$message.CANNOT_CHANGE_PASSWORD);
          this.passwordLoader = false;
          this.passwordBtnText = this.$message.GENERATE_PASSWORD;
        }
      } catch (err) {
        this.snackbar('error', err);
        this.passwordLoader = false;
        this.passwordBtnText = this.$message.GENERATE_PASSWORD;
      }
    },
    async getRoles() {
      try {
        this.loadingState = true;
        let tableData = await UserService.getActiveRoles();
        let tempData = tableData.data.body[0].roles.sort();
        tempData.forEach(ele => {
          let temp = {
            id: ele,
            val: ele
          };
          this.roleListWhole.push(temp);
          temp = {};
        });
        let listToBesent = JSON.parse(JSON.stringify(this.roleListWhole));
        this.roleList = this.setRoleList(listToBesent, this.roleSelectedList);
      } catch (err) {
        this.snackbar('error', err);
      } finally {
        this.loadingState = false;
      }
    },
    setRoleList(list) {
      return this.removeUnderscore(list);
    },
    addItems(item, arr) {
      let temp = {};
      let flag = findIndex(this.availableRoles, el => {
        return el.id === item;
      });
      if (flag >= 0 && item !== '') {
        let index = findIndex(arr, el => {
          return el.id === item;
        });
        if (index < 0) {
          let data = findIndex(this.availableRoles, el => {
            return el.id === item;
          });
          temp = {
            id: this.availableRoles[data].id,
            val: this.availableRoles[data].val
          };
        }
        arr.push(temp);
      }
      this.roleName = [];
    },
    deleteItem(item, arr) {
      let index = findIndex(arr, el => {
        return el.id === item.id;
      });
      if (index >= 0) {
        arr.splice(index, 1);
      }
    },
    setAliases() {
      let aliases = [];
      if (this.userDetails.secondaryEmails.length) {
        for (
          let index = 0;
          index < this.userDetails.secondaryEmails.length;
          index++
        ) {
          aliases.push({
            id: 'alias' + ++this.counter,
            val: this.userDetails.secondaryEmails[index],
            label: 'Email aliases:',
            status: false,
            validateEmailIcon: true,
            errorValidate: false,
            // is disabled
            addNewAliasIcon: true,
            addNewAliasIconVisible: false
          });
        }
        aliases[aliases.length - 1].addNewAliasIcon = false;
        aliases[aliases.length - 1].addNewAliasIconVisible = true;
        this.emailAlias = aliases;
      }
    },
    removeAlias(item) {
      if (this.emailAlias.length === this.min_length) {
        item.val = '';
        item.errorValidate = false;
        item.addNewAliasIconVisible = true;
        return;
      }
      let index = this.emailAlias.indexOf(item);
      if (index !== -1) {
        this.emailAlias.splice(index, 1);
      }
      let last_index = this.emailAlias.length;
      if (!this.emailAlias[last_index - 1].errorValidate) {
        this.emailAlias[last_index - 1].addNewAliasIconVisible = true;
        this.emailAlias[last_index - 1].addNewAliasIcon = false;
      }
    },
    validateEmail(email) {
      let emailAlias = this.emailAlias;
      let temp = this.emailValidate(email.val);
      let indexVal = findIndex(emailAlias, function(o) {
        return o.id === email.id;
      });
      if (temp) {
        emailAlias[indexVal].status = true;
        emailAlias[indexVal].val = email.val;
        emailAlias[indexVal].validateEmailIcon = true;
        emailAlias[indexVal].errorValidate = false;
        emailAlias[indexVal].addNewAliasIcon = false;
        if (this.emailAlias.length === this.min_length) {
          this.emailAlias[0].addNewAliasIconVisible = true;
        }
      } else {
        emailAlias[indexVal].status = false;
        emailAlias[indexVal].val = email.val;
        emailAlias[indexVal].validateEmailIcon = false;
        emailAlias[indexVal].errorValidate = true;
        emailAlias[indexVal].addNewAliasIcon = true;
      }
    },

    closeDialog(refreshUsers = false, refreshSummary = false) {
      this.$emit('closeOverlay', {
        refreshUsers: refreshUsers,
        refreshSummary: refreshSummary
      });
      this.showDialog = false;
    },
    next() {
      const tab_active = parseInt(this.tab);
      this.tab = tab_active + 1;
    },
    prev() {
      const tab_active = parseInt(this.tab);
      this.tab = tab_active - 1;
    },
    addAlias() {
      let emailAlias = this.emailAlias;
      for (let index = 0; index < emailAlias.length; index++) {
        const element = emailAlias[index];
        element.addNewAliasIcon = true;
        element.addNewAliasIconVisible = false;
      }
      if (emailAlias.length < this.emailAliasLimit) {
        emailAlias.push({
          id: `alias${++this.counter}`,
          label: '',
          value: '',
          status: false,
          validateEmailIcon: false,
          errorValidate: false,
          addNewAliasIcon: true,
          addNewAliasIconVisible: true
        });
      } else {
        alert('you have reached maximum limit');
      }
    },

    async changeMFAStatus(status, userDetails) {
      try {
        this.MFAloading = true;

        if (status) {
          const response = await UserService.changeMFAState({
            userId: userDetails.userId,
            type: 'configure'
          });
          if (response.data.success) {
            this.$set(userDetails.customData, 'ENABLED_2FA', true);
            // this.userDetails.customData.ENABLED_2FA = true;
            this.MFAStatusChanged = true;
          }
        } else {
          const response = await UserService.changeMFAState({
            userId: userDetails.userId,
            type: 'disable'
          });
          if (response.data.success) {
            this.$set(userDetails.customData, 'ENABLED_2FA', false);
            // this.userDetails.customdata.ENABLED_2FA = false;
            this.MFAStatusChanged = true;
          }
        }
        this.MFAloading = false;
        this.MFAStatusChanged = false;
      } catch {
        this.MFAloading = false;
        this.MFAStatusChanged = false;
      }
    },
    async saveVal() {
      try {
        this.loadingState = true;
        let temp = [];
        this.roleSelectedList.forEach(ele => {
          temp.push(ele.id);
        });
        let UserId = this.userDetails.userId;
        this.userDetails.secondaryEmails = [];
        this.emailAlias.forEach(ele => {
          if (ele.val) {
            this.userDetails.secondaryEmails.push(ele.val);
          }
        });
        let dataToBeSent = {
          addresses: this.userDetails.addresses,
          alias: this.userDetails.alias,
          department: this.userDetails.department,
          firstName: this.userDetails.firstName,
          jobTitle: this.userDetails.jobTitle,
          lastName: this.userDetails.lastName,
          licenseType: this.userDetails.license
            ? this.userDetails.license
            : 'company',
          middleName: this.userDetails.middleName,
          primaryEmail: this.userDetails.primaryEmail,
          roles: temp, //this.roleSelectedList,
          secondaryEmails: this.userDetails.secondaryEmails,
          status: this.userDetails.status,
          telephone: this.userDetails.telephone
        };
        await UserService.updateUser({
          userId: UserId,
          updateObj: dataToBeSent
        });
        let name = '';
        if (this.userDetails.firstName) {
          name += this.userDetails.firstName + ' ';
        }
        if (this.userDetails.middleName) {
          name += this.userDetails.middleName + ' ';
        }
        if (this.userDetails.lastName) {
          name += this.userDetails.lastName;
        }
        let msg = this.$message.UPDATE_SUCCESS;
        if (name !== '') {
          msg = `Updated account ${name} successfully`;
        }
        this.snackbar('success', msg);

        let statusChanged =
          this.originalStatus !== this.userDetails.status ? true : false;
        this.closeDialog(true, statusChanged);
      } catch (err) {
        this.snackbar('error', err);
      } finally {
        this.loadingState = false;
      }
    }
  },
  beforeDestroy() {}
};
</script>

<style scoped>
.vue-tel-input:focus-within {
  box-shadow: none;
  border-color: transparent;
}
.is-invalid {
  border-color: red;
}
.is-valid {
  border-color: #58e2c2;
}
.show-password {
  background: rgb(229, 229, 229);
}
span  {
  font-size: 16px;
}

.fname > div.v-input {
  padding-right: 10px !important;
}

.user-tab .v-tabs__container  {
  border-bottom: 1.5px solid rgba (27,  35,  66,  0.14);
}
.user-tab .v-tabs__div  {
  margin-right: 40px;
  font-size: 18px;
  line-height: initial;
  text-align: left;
  text-transform: capitalize;
}
.user-tab .v-tabs__item v-tabs__item--active  {
  font-weight: 600;
}
.user-tab .v-tabs__item  {
  padding-left: 0px;
  padding-right: 0px;
}
.user-tab  >  .v-toolbar__content  {
  padding: 0px !important;
}
.user-tab {
  box-shadow: none;
}

.customDialog .v-card .footerDialog {
  padding: 0;
}
</style>
